/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetNewsItem200ResponseDataConstructorInner
 */
export interface GetNewsItem200ResponseDataConstructorInner {
  /**
   *
   * @type {string}
   * @memberof GetNewsItem200ResponseDataConstructorInner
   */
  type: string
  /**
   *
   * @type {object}
   * @memberof GetNewsItem200ResponseDataConstructorInner
   */
  data?: object
}

/**
 * Check if a given object implements the GetNewsItem200ResponseDataConstructorInner interface.
 */
export function instanceOfGetNewsItem200ResponseDataConstructorInner(
  value: object
): value is GetNewsItem200ResponseDataConstructorInner {
  if (!('type' in value) || value['type'] === undefined) return false
  return true
}

export function GetNewsItem200ResponseDataConstructorInnerFromJSON(
  json: any
): GetNewsItem200ResponseDataConstructorInner {
  return GetNewsItem200ResponseDataConstructorInnerFromJSONTyped(json, false)
}

export function GetNewsItem200ResponseDataConstructorInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsItem200ResponseDataConstructorInner {
  if (json == null) {
    return json
  }
  return {
    type: json['type'],
    data: json['data'] == null ? undefined : json['data'],
  }
}

export function GetNewsItem200ResponseDataConstructorInnerToJSON(
  value?: GetNewsItem200ResponseDataConstructorInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    type: value['type'],
    data: value['data'],
  }
}
